import React, { memo } from 'react';
import Container from '../Utils/Container/Container';
import Grid from '../Utils/Grid/Grid';
import Col from '../Utils/Col/Col';
import ArticleIndexPageResultLoadingCard from '../ArticleIndexPage/ArticleIndexPageResultLoadingCard';

const GroupedArticleIndexPageLoading: React.FC = () => {
    return (
        <Container>
          <Grid>
            {/*-- side bar --*/}
            <Col span={{ default: 3 }} hideUntilBreakpoint='xl'>
              <aside className="h-full py-24 space-y-10">
                <div className="space-y-10">
                  <div className='bg-[#ededed] w-4/5 h-7' />
                  <ul className='space-y-6'>
                    {[1,2,3,4,5,6,7,8].map((loadingId: number) => (
                      <li key={`loading-side-bar-option--${loadingId}`} className='bg-[#ededed] w-4/6 h-4' />
                    ))}
                  </ul>
                </div>
              </aside>
            </Col>

            {/*-- main area --*/}
            <Col span={{ xl: 9 }} start={{ xl: 4 }}>
              <ul>
                <li className='py-24 space-y-16'>
                  <div className='bg-[#ededed] w-4/5 max-w-[400px] h-8' />
                  {/*-- top row --*/}
                  <Grid>
                    {[1,2].map((loadingId: number) => (
                      <Col key={`loading-card--${loadingId}`} span={{ md: 6 }}>
                        <ArticleIndexPageResultLoadingCard />
                      </Col>
                    ))}
                  </Grid>

                  {/*-- bottom row --*/}
                  <Grid>
                    {[1,2,3].map((loadingId: number) => (
                      <Col key={`loading-card--${loadingId}`} span={{ md: 4 }}>
                        <ArticleIndexPageResultLoadingCard />
                      </Col>
                    ))}
                  </Grid>
                </li>
              </ul>
            </Col>
          </Grid>
        </Container>
    );
}

export default memo(GroupedArticleIndexPageLoading);